// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 901) return "static/css/901.ade0c99c.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}